// start:ng42.barrel
export * from './collections.service';
// end:ng42.barrel

